import React, { useState } from "react"
import PropTypes from "prop-types"
import { Container, Select, Box } from "datastory-shared/ui"

import TrendLines from "../charts/TrendLines"

import { MissingDataNotification } from "components/blocks"

const TrendsView = ({
  sources,
  polls,
  trends,
  metaParties,
  metaPolls,
  xDomains,
  onXDomainChange,
  annotations,
  isCompleteDataLoaded,
}) => {
  const [source, setSource] = useState("mama")
  const { isArray } = Array

  if (
    !isArray(polls) ||
    !isArray(trends) ||
    !isArray(metaPolls) ||
    !isArray(metaParties)
  )
    return <MissingDataNotification />

  const trendsData =
    source === "mama" ? trends : polls.filter(d => d.og_pollster === source)

  return (
    <div data-cy="polls-chart-trends">
      <Container size="md">
        <TrendLines
          trends={trendsData}
          metaPolls={metaPolls}
          metaParties={metaParties}
          trendFormula={source}
          yDomain={[0, 40]}
          xDomains={xDomains}
          onXDomainChange={onXDomainChange}
          isCompleteDataLoaded={isCompleteDataLoaded}
          yTickValues={[0, 4, 15, 25, 35, 40]}
          annotations={annotations}
        >
          <Box gridColumn={["span 12", null, "span 5"]}>
            <Select
              onChange={setSource}
              options={sources}
              value={source}
              style={{ width: "100%" }}
              size="large"
            />
          </Box>
        </TrendLines>
      </Container>
    </div>
  )
}

TrendsView.propTypes = {
  polls: PropTypes.array,
  trends: PropTypes.array.isRequired,
  metaParties: PropTypes.array.isRequired,
  metaPolls: PropTypes.array.isRequired,
  sources: PropTypes.array,
  annotations: PropTypes.array,
  xDomains: PropTypes.array,
  onXDomainChange: PropTypes.func,
  isCompleteDataLoaded: PropTypes.bool,
}

export default TrendsView
